import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SocialSharePointIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialSharePoint",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M11.21 13.916c.559 0 1.076.143 1.569.383 1.455-4.05 5.243-6.664 9.542-6.646A10.14 10.14 0 0 0 15.117.34a10.1 10.1 0 0 0-10.45 3.41 10.07 10.07 0 0 0-1.492 10.166z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.447 10.118a8.7 8.7 0 0 0-8.332-.024 8.7 8.7 0 0 0-4.159 5.07c.557.627.914 1.4.98 2.236a7.95 7.95 0 0 1 5.062 2.09 7.97 7.97 0 0 1 2.538 6.935c3.876-.104 7.198-2.822 8.143-6.508a8.7 8.7 0 0 0-4.232-9.799M13.567 25.357l-.003-7.615c0-1.31-1.055-2.43-2.381-2.431l-7.731-.004a2.42 2.42 0 0 0-2.406 2.407l.003 7.73c0 1.346 1.14 2.385 2.46 2.384l7.604-.002a2.447 2.447 0 0 0 2.454-2.47m-3.591-2.05c-.093.822-.608 1.496-1.416 1.764a3.8 3.8 0 0 1-2.439-.028c-.66-.247-1.2-.697-1.51-1.317l1.357-.7a1.51 1.51 0 0 0 1.336.899c.534.016 1.011-.13 1.082-.672.09-.686-.528-.903-1.143-1.018a4.5 4.5 0 0 1-1.205-.385 1.89 1.89 0 0 1-1.076-1.794c.015-.505.156-.973.495-1.352a2.38 2.38 0 0 1 1.267-.733c1.231-.28 2.543.022 3.205 1.156l-1.327.683c-.155-.245-.346-.445-.61-.558a1.52 1.52 0 0 0-1.022.004.67.67 0 0 0-.411.591.67.67 0 0 0 .39.627c.502.242 1.101.223 1.794.549.95.447 1.35 1.242 1.233 2.285"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.953 18.792v6.621c-.001 2.076-1.695 3.797-3.777 3.8l-1.959.004a6.61 6.61 0 0 0 11.869-5.134c-.578-2.908-3.104-5.15-6.133-5.29"
    })]
  }));
};
SocialSharePointIcon.displayName = 'SocialSharePointIcon';